import { Tooltip } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
// import Typography from '@mui/material/Typography';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import imglogo from "../../asstes/AddFolder.png";
import Folder from "../../asstes/Folder.png";
import LogOut from "../../asstes/LogOut.png";

import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fileLength,
  logoutUser,
  setFolderGet,
  setFolderList,
  setFolderSearch,
  setModalFolder,
  setRefreshLoader,
  setbuttonTop,
} from "../../app/features/counterSlice";
import EyeFrame from "../../components/EyeFrame";
import EnhancedTable from "../../components/FolderLIst";
// import UploadDicom from '../UploadDicom/UploadDicom';
import cogoToast from "cogo-toast";
import { useEffect, useRef, useState } from "react";
import { IoMdShare } from "react-icons/io";
import { useSelector } from "react-redux";
import logo from "../../asstes/asd.png";
import CustomizedSnackbars from "../../components/CustomizedSnackbars";
import Info from "../../components/Info";
import ModalityCards from "../../components/StudyTable";
import ModalityByLabs from "../../components/SubFolder & studies";
import TrashTable from "../../components/TrashTable";
import ConnectBucket from "../ConnectBucket/ConnectBucket";
import NotificationsPage from "../Notifications/NotificationPage";
import TicketsPage from "../Tickets/TicketsPage";
import Check from "../UploadFiles";
import MultiFoldershare from "./../../components/MultiShareModal";
import { persistor } from "../../app/store";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#662583",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "#662583",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Dashboard({ fetchStudies }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const [cOpen1, setCOpen1] = React.useState(false);
  const [email, setEmail] = React.useState("");

  const [displayIFrame, setDisplayIFrame] = React.useState(false);
  const [tab, setTab] = React.useState(0);
  const [iframeValue, setIframeValue] = React.useState("");
  const [password, setPassword] = React.useState("");
  const state = useSelector((state) => state.user);
  //console.log(state, "stateuserstateuser");
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  //console.log(FolderGet, "FolderGetFolderGet");
  const modalFolder = useSelector((state) => state.modalFolder);
  const loader = useSelector((state) => state.loader);
  const [showImage, setShowImage] = React.useState(false);
  const RefreshLoader = useSelector((state) => state.RefreshLoader);
  const buttonTop = useSelector((state) => state.buttonTop);
  const CanUpload = useSelector((state) => state.isUpload);
  const isOnlyKeyImages = useSelector((state) => state.isOnlyKeyImages);
  const canShare = useSelector((state) => state.canShare);
  const token = localStorage.getItem("token");
  const [Fold, setFold] = React.useState("");
  const studyListButton = useSelector((state) => state.studyListButton);
  //console.log(studyListButton, "donedone");
  const setFileLength = useSelector((state) => state.fileLength);
  //console.log(setFileLength, "fileLengthfileLengthfileLengthfileLength");
  const [isOpen, setIsOpen] = React.useState(false);
  const [severity, setSeverty] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const a = useParams();
  const FolderList = useSelector((state) => state.FolderList);
  const folderGet = useSelector((state) => state.FolderGet);
  const [filterValue, setFilterValue] = useState("");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const notificationRef = useRef(null);
  //console.log(state, "statestate");
  // const HandleChange = (e) => {
  //   setFold(e.target.value);
  //   // //console.log(e.target.value,"changechange");
  //   if (e.target.value == "") {
  //     // //console.log("notnontnotn");
  //     dispatch(setFolderList([]));
  //   }
  // };
  const HandleChange = (e) => {
    let value = e.target.value;
    setFilterValue(value);
    // console.log(
    //   e.target.value,
    //   "e.target.valuee.target.valuee.target.valuee.target.value"
    // );
    if (value !== "") {
      let filterBySearch = [];
      if (FolderGet && typeof folderGet.FolderName == "string") {
        if (folderGet.FolderName.toLowerCase().includes(value.toLowerCase())) {
          filterBySearch = [folderGet.FolderName];
        }
      } else if (FolderGet) {
        filterBySearch = folderGet.FolderName.filter(
          (item) =>
            typeof item === "string" &&
            item.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        filterBySearch = FolderList.filter(
          (item) =>
            typeof item === "string" &&
            item.toLowerCase().includes(value.toLowerCase())
        );
      }

      if (filterBySearch.length > 0) {
        dispatch(setFolderSearch(filterBySearch));
        //console.log(filterBySearch, value, "searchvaluee11");
      } else {
        if (
          !window.location.href.includes("/StudyTable") &&
          tab === 4 &&
          window.location.href.includes("/SubFolder&studies")
        ) {
          //do nothing as rest is handled in subfolder & studies
        } else {
          cogoToast.error("No Folder Exist", {
            position: "top-right",
          });
          dispatch(setFolderSearch([]));
        }
        //console.log(FolderList, value, "searchvaluee");
      }
      dispatch(setFolderSearch(filterBySearch));
      //console.log(filterBySearch, value, "searchvaluee11");
    } else {
      dispatch(setFolderSearch([]));
      //console.log(FolderList, value, "searchvaluee");
    }
  };
  const location = useLocation();
  // const prevLocationRef = useRef();

  const isHidden = window.location.href.includes("/SubFolder&studies/");
  useEffect(() => {
    if (!window.location.href.includes("SubFolder&studies")) {
      // //console.log('Back button clicked or browser');
      if (window.location.href == `http://${window.location.host}/`) {
        // //console.log("this condition works well");
        if (tab == 4) {
          setTab(0);
        }
      }
    }
  }, [location]);

  useEffect(() => {
    dispatch(setFolderList([]));
    dispatch(setFolderSearch([]));
    dispatch(fileLength(0));
  }, []);

  // setRefreshLoader
  // //console.log(FolderGet, "147852369");
  // //console.log(
  //   modalFolder,
  //   "modalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodalmodal"
  // );
  // const dispatch = useDispatch();

  // const createFolders = () => {
  //   dispatch(createFolder(true));
  // };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleFolderIconClick = () => {
    setShowImage(true);
  };

  //console.log(tab, "tabbb");

  const callBack = () => {
    // alert();
    dispatch(setModalFolder(true));
  };

  // const SearchOption = async () => {
  //   try {
  //     let response = await axios.get(
  //       // `${DRCoreApi}fileloaderv1/files/GetSharedList?FolderName=${Fold}/`,
  //       `${DRCoreApi}fileloaderv1/files/GetFolderList?awsAccessKeyId=${AWS_Access_Key_Id_Encypt()}&awsSecretAccessKey=${AWS_Secret_Access_Key_Encypt()}&BucketName=${process.env.React_App_AWS_Bucket_Name_encypt}&folderName=${Fold}&Region=us-east-1`,

  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.data.length == 0) {
  //       cogoToast.error("Folder Didn't Exist", { position: "bottom-right" });
  //     }
  //     dispatch(setFolderList(response.data || []));
  //     // //console.log(response.data, "Ookokokokok");
  //   } catch (error) {
  //     //console.log(error);
  //   }
  // };

  // const fetchNotifications = async () => {
  //   try {
  //     const body = {
  //       pageNumber: 1,
  //       pageSize: 1,
  //       isRead: false,
  //       searchTerm: '',
  //       foldername: state.email
  //       // ...(isRead !== null && { isRead }),
  //       // ...(searchTerm !== "" && { searchTerm }),
  //     };
  //     const response = await fetch(`https://f067-39-39-61-57.ngrok-free.app/fileloaderv1/Notifications/GetAllNotifications`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(body),
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       //console.log(result?.data?.list, "API Response");
  //       dispatch(setNotifciationList(result?.data?.list || []))
  //       // setNotiList(result?.data?.list || []);
  //     } else {
  //       // const errorData = await response.json();
  //       console.error("Error from server:");
  //       // return rejectWithValue(errorData);
  //     }
  //   }
  //   catch (error) {
  //     //console.log("API call failed:", error);
  //   }

  // }
  // useEffect(() => {
  //   fetchNotifications()
  // }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setIsNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const searchInput = document.getElementById("search-dropdown");
    if (searchInput) {
      searchInput.value = ""; // Clear the input field
    }
  }, []);

  useEffect(() => {
    if (!tab || tab > 9) {
      setTab(0);
    }
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
      <MultiFoldershare
        cOpen={cOpen1}
        setCOpen={setCOpen1}
        email={email}
        // cpass={cPass}
        // cAccession={cAccession}
      />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant="h6" noWrap component="div">
            Mini variant drawer
          </Typography> */}
          <img src={logo} width="80px" alt="img" />
          {/* {tab === 3 && ( */}
          {/* {//console.log(buttonTop,"buttonTopbuttonTopbuttonTop") } */}
          {(tab === 0 || tab === 4) && !buttonTop ? (
            <>
              {/* {//console.log(tab, buttonTop, "conditon true")} */}
              {/* search bar */}
              <div
                class={`flex absolute ${
                  isHidden ? "right-[4rem]" : "right-[7rem]"
                }`}
              >
                <div class="relative w-full">
                  <form autocomplete="off">
                    <input
                      //  ref={(input) => input && input.setAttribute("autocomplete", "off")}
                      onChange={HandleChange}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          // SearchOption();
                        }
                      }}
                      type="search"
                      id="search-dropdown"
                      class="block p-1.5 pl-3 shadow-lg w-[9rem]  lg:w-[19rem] md:w-[19rem] sm:w-[19rem] z-20 text-sm text-gray-900 bg-white rounded-lg border-s-gray-50 border-s-2 border border-gray-300 "
                      placeholder="Search Folder "
                      required
                      // type="hidden" value="something"
                    />
                  </form>
                  <button
                    // onClick={SearchOption}
                    type="submit"
                    class="absolute top-0 end-0 p-1.5 text-sm font-medium h-full text-white bg-[#662583] rounded-e-lg border border-[#662583] hover:bg-[#6e4880]"
                  >
                    <svg
                      class="w-4 h-4"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                      />
                    </svg>
                    <span class="sr-only">Search</span>
                  </button>
                </div>
              </div>
              {/* <Tooltip title="Notifications" placement="bottom">
                <div
                  ref={notificationRef}
                  className=" flex justify-center items-center bg-[#5284C3] h-8 w-8 rounded-lg absolute right-28"
                  // style={{
                  //   visibility: !FolderGet ? "visible" : "hidden",
                  // }}
                  alt="img"
                  onClick={() => setIsNotificationOpen(!isNotificationOpen)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FFF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-bell-dot cursor-pointer"
                  >
                    <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                    <path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665" />
                    <circle cx="18" cy="8" r="3" />
                  </svg>
                  {isNotificationOpen && <Notification tab={tab} setTab={setTab} />}
                </div>
              </Tooltip> */}
              {(!isHidden && !FolderGet) || (!isHidden && canShare) ? ( // ✅ Hide tooltip when on SubFolder&studies/...
                <Tooltip title="Create Folder" placement="bottom">
                  <div
                    className="flex justify-center items-center bg-[#c48bde] h-8 w-8 rounded-lg absolute right-16"
                    onClick={() => callBack()}
                  >
                    <img src={imglogo} className="h-5 cursor-pointer" />
                  </div>
                </Tooltip>
              ) : (
                ""
              )}
              <Tooltip title="Reload" placement="bottom">
                <div
                  className=" flex justify-center items-center bg-[#c48bde] h-8 w-8 rounded-lg absolute right-4"
                  style={{
                    visibility: !FolderGet ? "visible" : "hidden",
                  }}
                  alt="img"
                  onClick={() => dispatch(setRefreshLoader(!RefreshLoader))}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FFF"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-rotate-ccw"
                  >
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                    <path d="M3 3v5h5" />
                  </svg>
                  {/* <img src={LoaderIcon} className="h-6 cursor-pointer" /> */}
                </div>
              </Tooltip>
              {/* <VscNewFolder /> */}
            </>
          ) : null}
          {/* )} */}
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose} className="side-icon">
            {theme.direction === "rtl" ? (
              <ChevronRightIcon color="white" />
            ) : (
              <ChevronLeftIcon color="white" />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <List>
          {/* study list */}

          {/* {studyListButton && (
            <Tooltip title="Study List">
              <ListItem
                key={"Study List"}
                disablePadding
                sx={{ display: "block" }}
                // style={{ background: `${tab === 5 ? `#5284C3` : `none`}`,}}
                onClick={() => {
                  setTab(5);
                  navigate("/");
                }}
                style={{
                  color: `#fff`,
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => setDisplayIFrame(false)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        background: `${tab === 5 ? `#5284C3` : `#4a5568`}`,
                      }}
                      className={`bg-[${
                        tab === 5 ? "#5284C3" : "#4a5568"
                      }] flex justify-center items-center h-7 w-7 rounded-lg`}
                    >
                      <img
                        src={HomeList}
                        alt="HomeList"
                        width="20px"
                        height="20px"
                      />
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Study List"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </Tooltip>
          )} */}

          {/* Folder */}
          <Tooltip title={open ? "" : "Folders"} placement="right">
            <ListItem
              key={"Folders"}
              disablePadding
              sx={{ display: "block" }}
              // style={{ background: `${tab === 0 ? `#5284C3` : `none`}` }}
              onClick={() => {
                if (setFileLength > 0) {
                  let confirmExit = window.confirm(
                    "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                  );
                  if (confirmExit) {
                    navigate("/");
                    setTab(0);
                    dispatch(fileLength(0));
                  }
                } else {
                  navigate("/");
                  setTab(0);
                }
                // setTab(0);
                dispatch(setbuttonTop(false));
                // //console.log(buttonTop,"buttonTopbuttonTopbuttonTop2");
                // navigate("/");
                handleFolderIconClick(); // Call the function on "Folders" item click
              }}
              style={{
                color: `#fff`,
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => setDisplayIFrame(false)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <div
                    // style={{
                    //   background: `${tab === 0 ? `#5284C3` : `#4a5568`}`,
                    // }}
                    className={`bg-[${
                      tab === 0 ? "#5284C3" : ""
                    }] flex justify-center items-center h-7 w-7 rounded-lg`}
                  >
                    {/* <FolderIcon className={`${"whiteColor"}`} /> */}
                    {/* Folder.png */}
                    <img src={Folder} alt="Folder" width="20px" height="20px" />
                  </div>
                </ListItemIcon>
                <ListItemText
                  primary={!FolderGet ? "Folders" : FolderGet}
                  sx={{ opacity: open ? 1 : 0 }}
                  primaryTypographyProps={{ fontSize: "0.8rem" }}
                />
              </ListItemButton>
            </ListItem>
          </Tooltip>
          {CanUpload && !isOnlyKeyImages && (
            <Tooltip title={open ? "" : "Upload images"} placement="right">
              <ListItem
                key={"Upload Images"}
                disablePadding
                sx={{ display: "block" }}
                style={{
                  // background: `${tab === 1 ? `#5284C3` : `none`}`,
                  color: `#fff`,
                }}
                onClick={() => {
                  if (setFileLength > 0) {
                    let confirmExit = window.confirm(
                      "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                    );
                    if (confirmExit) {
                      navigate("/");
                      setTab(1);
                      dispatch(fileLength(0));
                    }
                  } else {
                    navigate("/");
                    setTab(1);
                  }
                  // setTab(1);
                  // navigate("/");
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => setDisplayIFrame(false)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      // style={{
                      //   background: `${tab === 1 ? `#5284C3` : `#4a5568`}`,
                      //   // color: `${tab === 1 ? `#fff` : `black`}`,
                      // }}
                      className={`bg-[${
                        tab === 1 ? "#5284C3" : ""
                      }] flex justify-center items-center h-7 w-7 rounded-lg`}
                    >
                      {/* <CloudUploadIcon className={`${`whiteColor`}`} /> 
                      FileUpload.png
                      */}
                      {/* <img
                          src={FileUpload}
                          alt="FileUpload"
                          width="20px"
                          height="20px"
                        /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#FFF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-file-up"
                      >
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M12 12v6" />
                        <path d="m15 15-3-3-3 3" />
                      </svg>
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Upload Images"}
                    sx={{ opacity: open ? 1 : 0 }}
                    primaryTypographyProps={{ fontSize: "0.8rem" }}
                  />
                </ListItemButton>
              </ListItem>
            </Tooltip>
          )}

          {state?.email === "operations@medicalrecordcollation.com" ||
          state?.email === "zaid@gmail.com" ||
          state?.email === "danish@gmail.com" ? (
            <>
              {/* Upload images */}
              <Tooltip title={open ? "" : "Upload images"} placement="right">
                <ListItem
                  key={"Upload Images"}
                  disablePadding
                  sx={{ display: "block" }}
                  style={{
                    // background: `${tab === 1 ? `#5284C3` : `none`}`,
                    color: `#fff`,
                  }}
                  onClick={() => {
                    if (setFileLength > 0) {
                      let confirmExit = window.confirm(
                        "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                      );
                      if (confirmExit) {
                        navigate("/");
                        setTab(1);
                        dispatch(fileLength(0));
                      }
                    } else {
                      navigate("/");
                      setTab(1);
                    }
                    // setTab(1);
                    // navigate("/");
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                    onClick={() => setDisplayIFrame(false)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        // style={{
                        //   background: `${tab === 1 ? `#5284C3` : `#4a5568`}`,
                        //   // color: `${tab === 1 ? `#fff` : `black`}`,
                        // }}
                        className={`bg-[${
                          tab === 1 ? "#5284C3" : ""
                        }] flex justify-center items-center h-7 w-7 rounded-lg`}
                      >
                        {/* <CloudUploadIcon className={`${`whiteColor`}`} /> 
                      FileUpload.png
                      */}
                        {/* <img
                          src={FileUpload}
                          alt="FileUpload"
                          width="20px"
                          height="20px"
                        /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#FFF"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-file-up"
                        >
                          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                          <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                          <path d="M12 12v6" />
                          <path d="m15 15-3-3-3 3" />
                        </svg>
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Upload Images"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip>
              {/* Bucket  connnect */}
              {/* <Tooltip title={open ? "" : "Connect Bucket"} placement="right">
                <ListItem
                  key={"Connect Bucket"}
                  disablePadding
                  sx={{ display: "block" }}
                  // style={{ background: `${tab === 2 ? `#5284C3` : `none`}` }}
                  onClick={() => {
                    if (setFileLength > 0) {
                      let confirmExit = window.confirm(
                        "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                      );
                      if (confirmExit) {
                        navigate("/");
                        setTab(2);
                        dispatch(fileLength(0));
                      }
                    } else {
                      navigate("/");
                      setTab(2);
                    }
                  }}
                  style={{
                    color: `#fff`,
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className={`bg-[${
                          tab === 2 ? "#5284C3" : ""
                        }] flex justify-center items-center h-7 w-7 rounded-lg`}
                      >
                        <img
                          src={Bucket}
                          alt="Bucket"
                          width="20px"
                          height="20px"
                        />
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Connect Bucket"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip> */}

              {/*Notifications*/}
              {/* <Tooltip title="Notifications" placement="right">
                <ListItem
                  key={"Notifications"}
                  disablePadding
                  sx={{ display: "block" }}
                  // style={{ background: `${tab === 2 ? `#5284C3` : `none`}` }}
                  onClick={() => {
                    navigate("/");
                    setTab(8);
                  }}
                  style={{
                    color: `#fff`,
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        // style={{
                        //   background: `${tab === 8 ? `#5284C3` : `#4a5568`}`,
                        // }}
                        className={`bg-[${tab === 8 ? "#5284C3" : ""
                          }] flex justify-center items-center h-7 w-7 rounded-lg`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#fff"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-bell-dot cursor-pointer"
                        >
                          <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                          <path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665" />
                          <circle cx="18" cy="8" r="3" />
                        </svg>
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Notifications"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip>
              <Tooltip title="Ticket" placement="right">
                <ListItem
                  key={"Tickets"}
                  disablePadding
                  sx={{ display: "block" }}
                  // style={{ background: `${tab === 2 ? `#5284C3` : `none`}` }}
                  onClick={() => {
                    navigate("/");
                    setTab(9);
                  }}
                  style={{
                    color: `#fff`,
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        // style={{
                        //   background: `${tab === 8 ? `#5284C3` : `#4a5568`}`,
                        // }}
                        className={`bg-[${tab === 9 ? "#5284C3" : ""
                          }] flex justify-center items-center h-7 w-7 rounded-lg`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                          height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg>
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Tickets"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip> */}

              {/* Share Multiple Folders */}
              <Tooltip title={open ? "" : "Share Folders"} placement="right">
                <ListItem
                  key={"Share Folders"}
                  disablePadding
                  sx={{ display: "block" }}
                  // style={{ background: `${tab === 0 ? `#5284C3` : `none`}` }}
                  onClick={() => {
                    setCOpen1(true);
                    setEmail("new");
                  }}
                  style={{
                    color: `#fff`,
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                    // onClick={() => setDisplayIFrame(false)}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={
                          {
                            // background: `${
                            //   // tab === 0 ? `#5284C3` :
                            //   `#4a5568`
                            // }`,
                          }
                        }
                        className={`bg-[${
                          // tab === 0 ? "#5284C3" :
                          ""
                        }] flex justify-center items-center h-7 w-7 rounded-lg`}
                      >
                        <IoMdShare className="h-6 w-6 text-white" />{" "}
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Share Folders"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip>
              {/* Trash */}

              <Tooltip title={open ? "" : "Archive/Trash"} placement="right">
                <ListItem
                  key={"Trash"}
                  disablePadding
                  // className="bottom-0"
                  sx={{ display: "block" }}
                  style={{
                    color: `#fff`,
                  }}
                  onClick={() => {
                    if (setFileLength > 0) {
                      let confirmExit = window.confirm(
                        "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                      );
                      if (confirmExit) {
                        setTab(7);
                        dispatch(fileLength(0));
                      }
                    } else {
                      setTab(7);
                    }
                  }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        // style={{
                        //   background: `${tab === 7 ? `#5284C3` : `#4a5568`}`,
                        // }}
                        className={`bg-[${
                          tab === 7 ? "#5284C3" : ""
                        }] flex justify-center items-center h-7 w-7 rounded-lg `}
                      >
                        {/* <HiArchiveBoxArrowDown className="text-white" />  */}
                        <RiDeleteBin6Line className=" h-6 w-6 text-white" />
                      </div>
                    </ListItemIcon>
                    <ListItemText
                      primary={"Trash"}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip>
              {/* Info button  */}
            </>
          ) : (
            ""
          )}
          <Tooltip title={open ? "" : "Activity Logs"} placement="right">
            <ListItem
              key={"Activity Logs"}
              disablePadding
              // className="bottom-9"
              // className="bottom-0"
              sx={{ display: "block" }}
              style={{
                color: `#fff`,
              }}
              onClick={() => {
                if (setFileLength > 0) {
                  let confirmExit = window.confirm(
                    "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                  );
                  if (confirmExit) {
                    setTab(6);
                    dispatch(fileLength(0));
                  }
                } else {
                  setTab(6);
                }
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <div
                    // style={{
                    //   background: `${tab === 6 ? `#5284C3` : `#4a5568`}`,
                    // }}
                    className={`bg-[${
                      tab === 6 ? "#5284C3" : ""
                    }] flex justify-center items-center h-7 w-7 rounded-lg`}
                  >
                    {/* <img
                          src={historyIcon}
                          className="mx-3"
                          height="18px"
                          width="18px"
                          alt="img"
                        /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#FFF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-file-clock"
                    >
                      <path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" />
                      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                      <circle cx="8" cy="16" r="6" />
                      <path d="M9.5 17.5 8 16.25V14" />
                    </svg>{" "}
                    {/* <LuInfo className={`${`whiteColor`}`} /> */}
                  </div>
                </ListItemIcon>
                <ListItemText
                  primary={"Activity Log"}
                  sx={{ opacity: open ? 1 : 0 }}
                  primaryTypographyProps={{ fontSize: "0.8rem" }}
                />
              </ListItemButton>
            </ListItem>
          </Tooltip>

          {/* Logout */}
          <Tooltip title={open ? "" : "Logout"} placement="right">
            <ListItem
              key={"Logout"}
              disablePadding
              className="bottom-0"
              sx={{ display: "block" }}
              style={{
                color: `#fff`,
                position: "fixed", // Ensuring it stays at the bottom
                bottom: "0", // Placing it at the bottom of the screen
                width: "67px",
              }}
              // sx={{ display: "block" }}
              onClick={() => {
                dispatch(setFolderGet(""));
                persistor.purge();
                //console.log("done here dashboard file");
                if (setFileLength > 0) {
                  let confirmExit = window.confirm(
                    "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
                  );
                  if (confirmExit) {
                    dispatch(logoutUser());
                    cogoToast.success("Logout Successfully", {
                      position: "top-right",
                    });
                    navigate("/signin");
                    localStorage.clear();
                  }
                } else {
                  dispatch(logoutUser());
                  cogoToast.success("Logout Successfully", {
                    position: "top-right",
                  });
                  navigate("/signin");
                  localStorage.clear();
                }
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <div className="flex justify-center items-center h-7 w-7 rounded-lg">
                    {/* <LogoutIcon className={`${`whiteColor`}`} /> */}
                    <img src={LogOut} alt="LogOut" width="20px" height="20px" />
                  </div>
                </ListItemIcon>
                <ListItemText
                  primary={"Logout"}
                  sx={{ opacity: open ? 1 : 0 }}
                  primaryTypographyProps={{ fontSize: "0.8rem" }}
                />
              </ListItemButton>
            </ListItem>
          </Tooltip>
        </List>

        {/* <Divider /> */}
      </Drawer>
      <Box
        component="main"
        className={`top-[10vh] relative px-[1.25rem] ${
          displayIFrame ? "pb-3 pt-0" : "py-3"
        }`}
        sx={{ flexGrow: 1 }}
      >
        {/* <DrawerHeader /> */}
        {
          tab === 0 ? (
            displayIFrame ? (
              <EyeFrame
                tab={tab}
                iframeValue={iframeValue}
                password={password}
                setTab={setTab}
                setDisplayIFrame={setDisplayIFrame}
              />
            ) : (
              // <>Ahmed</>
              // <ModalityCards/>:
              !window.location.href.includes("/StudyTable") && (
                <EnhancedTable
                  setDisplayIFrame={setDisplayIFrame}
                  setPassword={setPassword}
                  setIframeValue={setIframeValue}
                  setTab={setTab}
                />
              )
            )
          ) : tab === 1 ? (
            <Check setTab={setTab} />
          ) : tab === 6 ? (
            <Info />
          ) : tab === 7 ? (
            <TrashTable />
          ) : tab === 2 ? (
            <ConnectBucket />
          ) : tab === 3 ? (
            <EnhancedTable
              setDisplayIFrame={setDisplayIFrame}
              setPassword={setPassword}
              setIframeValue={setIframeValue}
              setTab={setTab}
            />
          ) : !window.location.href.includes("/StudyTable") &&
            tab === 4 &&
            window.location.href.includes("/SubFolder&studies") ? (
            <ModalityByLabs
              setDisplayIFrame={setDisplayIFrame}
              setPassword={setPassword}
              setIframeValue={setIframeValue}
              setTab={setTab}
              filterValue={filterValue}
            />
          ) : tab === 4 && window.location.href.includes("StudyTable") ? (
            <ModalityCards
              setDisplayIFrame={setDisplayIFrame}
              setPassword={setPassword}
              setIframeValue={setIframeValue}
              setTab={setTab}
            />
          ) : tab === 5 ? (
            <ModalityCards
              setDisplayIFrame={setDisplayIFrame}
              setPassword={setPassword}
              setIframeValue={setIframeValue}
              setTab={setTab}
            />
          ) : tab === 8 ? (
            <NotificationsPage />
          ) : (
            tab === 9 && <TicketsPage />
          )

          // <UploadDicom />
        }
      </Box>
    </Box>
  );
}
